/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { formatMoney as formatMoneySarsa } from 'sarsaparilla';
import { gnoment } from 'shared-ui/gnoment';

const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9]+$/;

export const licensePlateValidator = (value) => {
    if (!value || ALPHANUMERIC_REGEX.test(value)) {
        return { isValid: true, formattedValue: value };
    }

    // License plate may only contain letters and numbers, so we need to remove any non-alphanumeric characters
    const formattedValue = value.replace(/[^a-zA-Z0-9]/g, '');
    return {
        isValid: true,
        formattedValue,
    };
};

export function formatMoney(val) {
    return formatMoneySarsa(val);
}

export function formatDate(val) {
    return gnoment(val).utc().format('ll');
}
